/* eslint-disable no-unused-expressions */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Checkbox } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { useTranslation } from 'react-i18next';

const MultiSelect = ({
  items,
  fieldName,
  classes,
  selectedValues,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  onChange,
}) => {
  const filter = createFilterOptions();

  function filteringWagonNumber(wagonNumberItem, searchValue) {
    let input = searchValue;
    let endingWord = true;
    let beginWord = true;
    if (
      searchValue.startsWith('*') &&
      searchValue.endsWith('*') &&
      searchValue.length > 1
    ) {
      input = searchValue.substring(1, searchValue.lastIndexOf('*'));
      endingWord = !wagonNumberItem.endsWith(input);
      beginWord = !wagonNumberItem.startsWith(input);
    } else if (searchValue.startsWith('*')) {
      input = searchValue.substring(1);
      beginWord = !wagonNumberItem.startsWith(input) || input.length === 0;
      endingWord = wagonNumberItem.endsWith(input);
    } else if (searchValue.endsWith('*')) {
      input = searchValue.substring(0, searchValue.lastIndexOf('*'));
      endingWord = !wagonNumberItem.endsWith(input);
      beginWord = wagonNumberItem.startsWith(input);
    }
    return wagonNumberItem.includes(input) && endingWord && beginWord;
  }

  const [filterString, setFilterString] = React.useState('');

  const allSelected = items.length === selectedValues.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };
  const { t } = useTranslation();

  function getFiltered() {
    let filtered;

    if (fieldName === 'wagonNumber') {
      filtered = items.filter((item) =>
        filteringWagonNumber(item, filterString),
      );
    } else {
      filtered = items.filter(
        (i) => i.toLowerCase().indexOf(filterString.toLowerCase()) >= 0,
      );
    }
    return filtered;
  }

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === 'select-option' || reason === 'remove-option') {
      if (selectedOptions.find((option) => option === 'select all')) {
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === 'clear') {
      onClearOptions && onClearOptions();
    }
    const selectAll = selectedOptions.find((option) => option === 'select all');
    if (!allSelected && selectAll) {
      if (filterString.length > 0) {
        const filteredItems = getFiltered();
        onChange(event, filteredItems);
      } else {
        onChange(event, items);
      }
    } else if (selectAll) {
      onChange(event, []);
    } else {
      onChange(event, selectedOptions);
    }
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option === 'select all' ? { checked: allSelected } : {};
    return (
      <>
        <Checkbox
          classes={{
            root: classes.root,
            checked: classes.checked,
          }}
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          checked={selected}
          {...selectAllProps}
        />
        <>
          <Typography className={classes.multiSelectOption}>
            {option !== null && option !== '' ? t(option) : '-'}
          </Typography>
        </>
      </>
    );
  };
  const getOptionSelected = (option, anotherOption) => option === anotherOption;

  const preventNonNumericalInput = (e) => {
    if (fieldName === 'wagonNumber') {
      const charCode = typeof e.which === 'undefined' ? e.keyCode : e.which;
      const charStr = String.fromCharCode(charCode);
      if (!charStr.match(/^\*|[0-9]+$/)) e.preventDefault();
    }
  };

  const handleInputChange = (event, newInputValue) => {
    if (event && fieldName === 'wagonNumber') {
      if (event.nativeEvent.inputType === 'insertCompositionText') {
        newInputValue = newInputValue.replace(/¨|\^|`?/g, '');
      }
      if (event.nativeEvent.inputType === 'insertFromPaste') {
        newInputValue
          .replace(/[^0-9*]+/g, '')
          .replace(
            /¨|\^|`|-|ù|%|£|=|\+|:|\/|;|\.|,|\?|<|>|e|ä|ë|ï|ö|ü|Ë|Ä|Ï|Ö|Ü?/g,
            '',
          );
      }
    }
    setFilterString(newInputValue);
  };

  const Pop = (props) => {
    const { className, anchorEl, style, ...rest } = props;
    const bound = anchorEl.getBoundingClientRect();
    return (
      <div
        {...rest}
        style={{
          position: 'absolute',
          zIndex: 9999,
          width: bound.width,
        }}
      />
    );
  };

  return (
    <Autocomplete
      multiple
      size="small"
      PopperComponent={Pop}
      limitTags={4}
      ListboxProps={{ className: classes.listBox }}
      options={items}
      value={selectedValues}
      disableCloseOnSelect
      getOptionSelected={getOptionSelected}
      filterOptions={(options, params) => {
        let filtered;
        if (fieldName === 'wagonNumber') {
          filtered = items.filter((item) =>
            filteringWagonNumber(item, params.inputValue),
          );
        } else {
          filtered = filter(options, params);
        }
        const filteredFirst100 = filtered.slice(0, 100);
        return filtered.length > 0
          ? ['select all', ...filteredFirst100]
          : filteredFirst100;
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={{ shrink: true }}
          fullWidth
          className={classes.autoCompleteTextBox}
        />
      )}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            label={option !== null && option !== '' ? option : '-'}
          />
        ));
      }}
      onInputChange={handleInputChange}
      onKeyPress={preventNonNumericalInput}
    />
  );
};

MultiSelect.defaultProps = {
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
};

export default MultiSelect;
